module.exports = __webpack_public_path__ + "static/img/4.af6742c.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/1/3/eng/4.png
// module id = Peg2
// module chunks = 0